import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { FormattingDataService } from '@app/core/services/formatting-data/formatting-data.service';
import { FpCorrelationGraphStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph/fp-correlation-graph.store';
import { NgClass } from '@angular/common';

@Component({
  selector: 'gc-fp-correlation-graph-info-leak',
  standalone: true,
  imports: [TranslatePipe, TranslateDirective, NgClass],
  templateUrl: './fp-correlation-graph-info-leak.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpCorrelationGraphInfoLeakComponent {
  public readonly currentTabStore = inject(FpCorrelationGraphStore);
  protected readonly formattingData = inject(FormattingDataService);

  public shortView = input<boolean>(false);
  public isMinimizedView = input<boolean>(false);

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  public readonly correlation = computed(() => this.popupMainData()?.correlation);

  public readonly logger1 = computed(() => {
    const logger = this.popupMainData()?.loggerDeployment1;

    return this.formattingData.formatSerialNo(logger?.serialNo);
  });

  public readonly logger2 = computed(() => {
    const logger = this.popupMainData()?.loggerDeployment2;

    return this.formattingData.formatSerialNo(logger?.serialNo);
  });

  public readonly distanceL1 = computed<string>(() => {
    const correlation = this.correlation();

    return this.formattingData.formatLength(
      correlation?.distanceL1,
      this.currentTabStore.viewMeasurementSystem(),
      !correlation?.pipeProvided
    );
  });

  public readonly distanceL2 = computed<string>(() => {
    const correlation = this.correlation();

    return this.formattingData.formatLength(
      correlation?.distanceL2,
      this.currentTabStore.viewMeasurementSystem(),
      !correlation?.pipeProvided
    );
  });
}
